import React from 'react';
import { components } from 'react-select';
export function AutoCompleteV2Option(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(components.Option, props, children);
}
//# sourceMappingURL=AutoCompleteV2Option.js.map